/**
 * Function to pluralize a word based on a count.
 * If the count is 1, it returns the singular form; otherwise, it returns the plural form.
 * If the plural form is not provided, it defaults to adding an "s" to the singular form.
 * @param count number
 * @param singular string
 * @param plural string | undefined
 * @returns string
 */
export function pluralize(count: number, singular: string, plural?: string): string {
  return count === 1 ? singular : plural || `${singular}s`
}
